import {
  ChangeDetectorRef,
  Component,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  GoogleMapsModule,
  MapMarker,
  MapInfoWindow,
} from '@angular/google-maps';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { MapService } from '@reenstudio/app/core/services/api/map.service';
import { EventService } from '@reenstudio/app/core/services/event-service';
import { StorageService } from '@reenstudio/app/core/services/storage.service';
import { CerService } from '@reenstudio/app/core/services/cer-service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-cer-map',
  templateUrl: './cer-map.component.html',
  styleUrls: ['./cer-map.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    GoogleMapsModule,
    HttpClientModule,
    HttpClientJsonpModule,
  ],
})
export class CerMapComponent implements OnInit {
  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;
  @ViewChildren(MapMarker) markers: QueryList<MapMarker>;

  constructor(
    private mapService: MapService,
    private storageService: StorageService,
    private cerService: CerService,
    private cdr: ChangeDetectorRef,
    private logger: NGXLogger
  ) {}

  display: any;
  center: google.maps.LatLngLiteral;

  infoContent: string = '';
  points: any[];
  zoom = 13;

  ngOnInit(): void {
    this.center = this.mapCoordinates();
    console.log('Center', this.center);
    this.points = this.mapService.getSitesMarkers();

    EventService.changeCer.subscribe(() => {
      this.ngOnInit();
    });
  }

  move(event: google.maps.MapMouseEvent) {
    if (event.latLng != null) this.display = event.latLng.toJSON();
  }

  openInfoWindow(windowIndex: number, content: string) {
    this.markers.forEach((marker: MapMarker, ix: number) => {
      if (windowIndex === ix) {
        this.infoContent = content;
        this.infoWindow.open(marker);
      }
    });
  }

  closeInfoWindow() {
    this.infoWindow.close();
  }

  mapCoordinates() {
    const cerId: number | null = this.storageService.getCer();

    if (cerId) {
      const cer = this.cerService.getStorageCer(cerId);
      if (cer) {
        const { latitude, longitude } = JSON.parse(cer.position_json);

        this.logger.debug('Map Coordinates', latitude, longitude);
        return {
          lat: Number.parseFloat(latitude),
          lng: Number.parseFloat(longitude),
        };
      }
    }
    return {
      lat: 0,
      lng: 0,
    };
  }
}
